import { sortBy } from "lodash";

interface Coordinates {
    clientX: number;
    clientY: number;
    pageX: number;
    pageY: number;
}

interface DropHandler {
    key: string;
    targetElement?: HTMLElement;
    callback: (droppedData: any, droppedRect: DOMRect) => void;
}

export let mousePos: Coordinates = {
    clientX: undefined,
    clientY: undefined,
    pageX: undefined,
    pageY: undefined
};

let proxyElement: HTMLElement;
let mouseDown = false;
let currentDraggedKey: string = null;
let dropData: any = null;
let listenersDisposers: Function[] = [];
let handlers: DropHandler[] = []; // todo reduce instances on destroy
let onMouseMoveInProgress = null;

function isInBox(targetElement) {
    const rect = targetElement.getBoundingClientRect();
    if (rect.left > mousePos.clientX) {
        return false;
    }

    if (rect.left + rect.width < mousePos.clientX) {
        return false;
    }

    if (rect.top > mousePos.clientY) {
        return false;
    }

    return rect.top + rect.height >= mousePos.clientY;
}

function savePosition(event: MouseEvent) {
    mousePos = {
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}

const mouseMoveListener = (event: MouseEvent) => {
    savePosition(event);

    if (!mouseDown) {
        return;
    }

    if (proxyElement) {
        proxyElement.style.top = mousePos.clientY + "px";
        proxyElement.style.left = mousePos.clientX + "px";
    } else {
        if (onMouseMoveInProgress) {
            onMouseMoveInProgress();
        }
    }
};

const mouseUpListener = () => {
    mouseDown = false;
    if (!proxyElement) {
        return;
    }

    const targetRect = proxyElement.getBoundingClientRect();
    const registeredHandlersForGivenKey = handlers.filter(x => x.key === currentDraggedKey);

    registeredHandlersForGivenKey
        .filter(x => !x.targetElement)
        .forEach(handler => {
            handler.callback(dropData, targetRect);
        });

    const handlersMatchedByCoordinates = registeredHandlersForGivenKey.filter(
        x => x.targetElement && isInBox(x.targetElement)
    );
    const sortedSpecificHandlers = sortBy(handlersMatchedByCoordinates, handler => {
        const rect = handler.targetElement.getBoundingClientRect();
        return rect.width + rect.height;
    });

    if (sortedSpecificHandlers.length > 0) {
        sortedSpecificHandlers[0].callback(dropData, targetRect);
    }

    proxyElement.remove();
    proxyElement = null;
    dropData = null;
};

function initDnD() {
    window.addEventListener("mousemove", mouseMoveListener);
    window.addEventListener("mouseup", mouseUpListener);
}

/*
    Legacy drag and drop wrap for jQuery `.drop("start", .drop("drop"`, where using mousePos from this file.
        Used in FD select area, dashboard edit, etc.
*/
initDnD();

/* export function destroyDnD() {
    window.removeEventListener("mousemove", mouseMoveListener);
    window.removeEventListener("mouseup", mouseUpListener);
    listenersDisposers.forEach(disposer => disposer());
    listenersDisposers = [];
    mouseDown = false;
}*/
